// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reading-main {
    width: 100%;
}

.basic-reading {
    padding: 75px 45px;
    padding-bottom: 0%;
}

.reading-heading-div {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    gap: 50px;
}

.reading-heading-img-div>* {
    max-width: 100%;
    height: auto;
}

.reading-heading-text-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.reading-heading-text {
    font-size: 56px;
    font-weight: 400;
    line-height: 1.1;
    margin-bottom: 20px;
}

.reading-header-detail-text {
    font-size: 20px;
    line-height: 1.5;
    margin-top: 0px;
}

/* Books Section */
.books-section {
    padding: 48px 0;
}

.books-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 16px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
}

/* Book Card */
.book-card {
    border-radius: 8px;
    overflow: hidden;
    transition: box-shadow 0.3s ease;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.book-card:hover {
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

/* Book Cover */
.book-cover-container {
    position: relative;
    aspect-ratio: 3 / 4;
    overflow: hidden;
}

.book-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.book-card:hover .book-cover {
    transform: scale(1.05);
}

.book-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0);
    transition: background 0.3s ease;
}

.book-card:hover .book-overlay {
    background: rgba(0, 0, 0, 0.2);
}

/* Year Badge */
.book-year-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    z-index: 10;
    backdrop-filter: blur(8px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease;
}

.book-card:hover .book-year-badge {
    transform: scale(1.05);
}

/* Book Info */
.book-info {
    padding: 12px;
    flex: 1 1;
}

.book-title {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 4px 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.book-author {
    font-size: 12px;
    margin: 0;
    line-height: 1.3;
}

/* Responsive Design */
@media (min-width: 640px) {
    .books-container {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (min-width: 768px) {
    .books-container {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media (min-width: 1024px) {
    .books-container {
        grid-template-columns: repeat(6, 1fr);
    }
}

@media (max-width: 768px) {
    .basic-reading {
        padding: 30px 20px;
    }

    .reading-heading-div {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .reading-heading-text {
        font-size: 40px;
    }

    .reading-header-detail-text {
        font-size: 18px;
    }
}

/* Back to Top Button */
.back-to-top {
    position: fixed;
    bottom: 40px;
    right: 40px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    z-index: 1000;
    animation: fadeInUp 0.3s ease;
}

.back-to-top:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

.back-to-top:active {
    transform: translateY(-2px);
}

.back-to-top svg {
    transition: transform 0.3s ease;
}

.back-to-top:hover svg {
    transform: translateY(-3px);
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 768px) {
    .back-to-top {
        bottom: 20px;
        right: 20px;
        width: 45px;
        height: 45px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/reading/Reading.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,0BAA0B;IAC1B,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;AACd;IACI,aAAa;IACb,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,yBAAyB;IACzB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".reading-main {\n    width: 100%;\n}\n\n.basic-reading {\n    padding: 75px 45px;\n    padding-bottom: 0%;\n}\n\n.reading-heading-div {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));\n    gap: 50px;\n}\n\n.reading-heading-img-div>* {\n    max-width: 100%;\n    height: auto;\n}\n\n.reading-heading-text-div {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.reading-heading-text {\n    font-size: 56px;\n    font-weight: 400;\n    line-height: 1.1;\n    margin-bottom: 20px;\n}\n\n.reading-header-detail-text {\n    font-size: 20px;\n    line-height: 1.5;\n    margin-top: 0px;\n}\n\n/* Books Section */\n.books-section {\n    padding: 48px 0;\n}\n\n.books-container {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 0 16px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n}\n\n/* Book Card */\n.book-card {\n    border-radius: 8px;\n    overflow: hidden;\n    transition: box-shadow 0.3s ease;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.book-card:hover {\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n}\n\n/* Book Cover */\n.book-cover-container {\n    position: relative;\n    aspect-ratio: 3 / 4;\n    overflow: hidden;\n}\n\n.book-cover {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.3s ease;\n}\n\n.book-card:hover .book-cover {\n    transform: scale(1.05);\n}\n\n.book-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0);\n    transition: background 0.3s ease;\n}\n\n.book-card:hover .book-overlay {\n    background: rgba(0, 0, 0, 0.2);\n}\n\n/* Year Badge */\n.book-year-badge {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    z-index: 10;\n    backdrop-filter: blur(8px);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    transition: transform 0.3s ease;\n}\n\n.book-card:hover .book-year-badge {\n    transform: scale(1.05);\n}\n\n/* Book Info */\n.book-info {\n    padding: 12px;\n    flex: 1;\n}\n\n.book-title {\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0 0 4px 0;\n    line-height: 1.4;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.book-author {\n    font-size: 12px;\n    margin: 0;\n    line-height: 1.3;\n}\n\n/* Responsive Design */\n@media (min-width: 640px) {\n    .books-container {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (min-width: 768px) {\n    .books-container {\n        grid-template-columns: repeat(4, 1fr);\n    }\n}\n\n@media (min-width: 1024px) {\n    .books-container {\n        grid-template-columns: repeat(6, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .basic-reading {\n        padding: 30px 20px;\n    }\n\n    .reading-heading-div {\n        grid-template-columns: 1fr;\n        gap: 20px;\n    }\n\n    .reading-heading-text {\n        font-size: 40px;\n    }\n\n    .reading-header-detail-text {\n        font-size: 18px;\n    }\n}\n\n/* Back to Top Button */\n.back-to-top {\n    position: fixed;\n    bottom: 40px;\n    right: 40px;\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    transition: all 0.3s ease;\n    z-index: 1000;\n    animation: fadeInUp 0.3s ease;\n}\n\n.back-to-top:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);\n}\n\n.back-to-top:active {\n    transform: translateY(-2px);\n}\n\n.back-to-top svg {\n    transition: transform 0.3s ease;\n}\n\n.back-to-top:hover svg {\n    transform: translateY(-3px);\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@media (max-width: 768px) {\n    .back-to-top {\n        bottom: 20px;\n        right: 20px;\n        width: 45px;\n        height: 45px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
